// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedContentSidebar-cls1_B9P","cls2":"SuggestedContentSidebar-cls2_whR SuggestedContentSidebar-cls1_B9P"};